import { IconDefinition } from "@fortawesome/fontawesome-common-types";

import {
  faPlus as faPlusSharp,
  faMinus as faMinusSharp,
  faChevronDown as faChevronDownSharp,
  faChevronUp as faChevronUpSharp,
  faArrowRight as faArrowRightSharp,
  faSpinner as faSpinnerSharp,
  faUser as faUserSolidSharp,
  faBars as faBarsSolidSharp,
} from "@fortawesome/sharp-solid-svg-icons";

import {
  faArrowRight as faArrowRightRegularSharp,
  faArrowUpRight as faArrowUpRightRegularSharp,
  faArrowLeft as faArrowLeftRegularSharp,
  faArrowUp as faArrowUpRegularSharp,
  faChevronLeft as faChevronLeftRegularSharp,
  faChevronRight as faChevronRightRegularSharp,
  faXmark as faXMarkRegularSharp,
  faCircle as faCircleRegularSharp,
  faCircleCheck as faCircleCheckRegularSharp,
  faUpload as faUploadRegularSharp,
  faTrash as faTrashRegularSharp,
  faCheck as faCheckRegularSharp,
  faInfoCircle as faInfoCircleRegularSharp,
  faUser as faUserRegularSharp,
  faSearch as faSearchRegularSharp,
  faPhone as faPhoneRegularSharp,
  faEnvelope as faEnvelopeRegularSharp,
  faCamera as faCameraRegularSharp,
  faCopyright as faCopyRightRegularSharp,
} from "@fortawesome/sharp-regular-svg-icons";

enum FaIcons {
  Plus = "plus",
  Minus = "minus",
  ChevronDown = "chevron-down",
  ChevronUp = "chevron-up",
  ChevronLeftRegular = "chevron-left-regular",
  ChevronRightRegular = "chevron-right-regular",
  ArrowRight = "arrow-right",
  ArrowUpRight = "arrow-up-right",
  ArrowUp = "arrow-up",
  Spinner = "spinner",
  UserSolid = "user-solid",
  BarsSolid = "bars-solid",
  ArrowRightRegular = "arrow-right-regular",
  ArrowLeftRegular = "arrow-left-regular",
  XMarkRegular = "xmark",
  CircleRegular = "circle-regular",
  CircleCheckRegular = "circle-check-regular",
  UploadRegular = "upload-regular",
  TrashRegular = "trash-regular",
  CheckRegular = "check-regular",
  InfoCircleRegular = "info-circle-regular",
  UserRegular = "user-regular",
  SearchRegular = "search-regular",
  PhoneRegular = "phone-regular",
  EnvelopeRegular = "envelope-regular",
  CameraRegular = "camera-regular",
  CopyrightRegular = "copy-right-regular",
}

const iconLookup: Record<FaIcons, IconDefinition> = {
  [FaIcons.Plus]: faPlusSharp,
  [FaIcons.Minus]: faMinusSharp,
  [FaIcons.ChevronDown]: faChevronDownSharp,
  [FaIcons.ChevronUp]: faChevronUpSharp,
  [FaIcons.ChevronLeftRegular]: faChevronLeftRegularSharp,
  [FaIcons.ChevronRightRegular]: faChevronRightRegularSharp,
  [FaIcons.ArrowRight]: faArrowRightSharp,
  [FaIcons.ArrowUpRight]: faArrowUpRightRegularSharp,
  [FaIcons.ArrowUp]: faArrowUpRegularSharp,
  [FaIcons.Spinner]: faSpinnerSharp,
  [FaIcons.UserSolid]: faUserSolidSharp,
  [FaIcons.BarsSolid]: faBarsSolidSharp,
  [FaIcons.ArrowRightRegular]: faArrowRightRegularSharp,
  [FaIcons.ArrowLeftRegular]: faArrowLeftRegularSharp,
  [FaIcons.XMarkRegular]: faXMarkRegularSharp,
  [FaIcons.CircleRegular]: faCircleRegularSharp,
  [FaIcons.CircleCheckRegular]: faCircleCheckRegularSharp,
  [FaIcons.UploadRegular]: faUploadRegularSharp,
  [FaIcons.TrashRegular]: faTrashRegularSharp,
  [FaIcons.CheckRegular]: faCheckRegularSharp,
  [FaIcons.InfoCircleRegular]: faInfoCircleRegularSharp,
  [FaIcons.UserRegular]: faUserRegularSharp,
  [FaIcons.SearchRegular]: faSearchRegularSharp,
  [FaIcons.PhoneRegular]: faPhoneRegularSharp,
  [FaIcons.EnvelopeRegular]: faEnvelopeRegularSharp,
  [FaIcons.CameraRegular]: faCameraRegularSharp,
  [FaIcons.CopyrightRegular]: faCopyRightRegularSharp,
};

export const toIconProp = (faIcon: FaIcons): IconDefinition => {
  const icon = iconLookup[faIcon];
  if (icon) {
    return icon;
  }
  return null;
};

export default FaIcons;
